import * as React from 'react';
import { observer } from 'mobx-react-lite';
import getLocationMailTipMessageViewState from 'owa-calendar-meeting-forms-common-view/lib/utils/infoBarUtils/getLocationMailTipMessageViewState';
import getMailTips from 'owa-mail-tips/lib/selectors/getMailTips';
import getMailTipMessageViewStates from 'owa-mail-tips/lib/utils/getMailTipMessageViewStates';
import getAllAttendees from 'owa-calendar-compose-form-store/lib/selectors/getAllAttendees';
import getFromAddress from 'owa-calendar-compose-form-orchestration/lib/utils/getFromAddress';
import removeAttendees from 'owa-calendar-compose-form-actions/lib/actions/removeAttendees';
import onOpenAccessibilityChecker from 'owa-calendar-compose-form-actions/lib/actions/onOpenAccessibilityChecker';
import { getFullComposeInfoBarMessageViewStates } from 'owa-calendar-meeting-forms-common-view/lib/utils/getInfoBarMessageViewStates';
import { InfoBar } from 'owa-info-bar-view';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { containsRoomWithEmail } from 'owa-location-persona';
import { isFTDFSeriesMaster } from 'owa-calendar-event-capabilities';

let styles = require('./FullComposeForm.scss');

export interface FullComposeInfoBarProps {
    colorScheme: ColorScheme;
}

const FullComposeInfoBar: React.SFC<FullComposeInfoBarProps> = observer(props => {
    const { event, originalEvent, uiState } = getComposeStore();
    const locationMailtips = getLocationMailTipMessageViewState(event.Locations, getMailTips());
    const recipientsMailtips = getMailTipMessageViewStates(
        getAllAttendees().filter(
            attendee => !containsRoomWithEmail(event.Locations, attendee.EmailAddress)
        ),
        getMailTips(),
        getFromAddress(event.Organizer),
        !isFTDFSeriesMaster(event)
            ? removeAttendees
            : null /* pass null if it's edit from this date forward since we don't want to be able to remove attendees */,
        onOpenAccessibilityChecker
    );

    let infoBarViewStates = [
        ...getFullComposeInfoBarMessageViewStates(event, originalEvent, uiState),
        ...recipientsMailtips,
        ...locationMailtips,
    ];

    if (!infoBarViewStates || infoBarViewStates.length == 0) {
        // No infobar view states, then nothing to render
        return null;
    }

    return (
        <div className={styles.infoBarContainer}>
            <InfoBar
                className={styles.infoBar}
                textContainerClassName={styles.infobarText}
                colorScheme={props.colorScheme}
                messages={infoBarViewStates}
            />
        </div>
    );
});

export default FullComposeInfoBar;
